import { useMemo } from 'react';
import { useCurrentIdentity } from '../../useCurrentIdentity';
import { useTeamMembership } from './useTeamMembership';

const DIAM_PLATFORM_ADMIN_GRANT = 'PLATFORM_ADMIN';

export function useDiamPlatformAdmin() {
  const currentIdentityQuery = useCurrentIdentity();
  const currentIdentityId = currentIdentityQuery.data?.id;
  const membershipQuery = useTeamMembership(currentIdentityId);

  const isPlatformAdmin = useMemo(
    () =>
      (membershipQuery.data?.roles ?? []).some(
        role => role.grantAuthority === DIAM_PLATFORM_ADMIN_GRANT,
      ),
    [membershipQuery.data?.roles],
  );

  return {
    isPlatformAdmin,
    isPending:
      currentIdentityQuery.isPending ||
      (Boolean(currentIdentityId) && membershipQuery.isPending),
  };
}
